import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconSearch,
    iconPreAprobador,
    iconReports,
    iconReportsDefault,
    iconConcessionaireSecondary,
    iconAffiliate,
    iconParameters,
    iconDocs,
    DocsDesembolsados,
    iconConsults,
} from '../defaultValues';

const data = {
    role_32fe968d846d4544ab7da197760f16f2: [
        {
            id: 'requests',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'buro',
            icon: iconConsults,
            label: 'Consultas Buró',
            to: '/app/BuroConsults',
        },
        {
            id: 'clients',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'documentos',
            icon: iconDocs,
            label: 'Documentos',
            to: '/app/calculator',
            subs: [
                {
                    id: 'documents',
                    icon: DocsDesembolsados,
                    label: 'Desembolsados',
                    to: '/app/credits/DisbursementDocuments',
                },
            ],
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconConcessionaireSecondary,
                    label: 'Concesionarios',
                    to: '/app/concesionarios',
                },
                {
                    icon: iconAffiliate,
                    label: 'Aliados',
                    to: '/app/aliados',
                },
            ],
        },

        {
            id: 'pre-aprobador',
            icon: iconPreAprobador,
            label: 'Pre-aprobador',
            to: '/app/pre-aprobador',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Usuario',
                    to: '/app/reports/teamPerformance',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
            ],
        },
    ],
};
export default data;
